import * as React  from "react";
import { useState } from "react";
import axios from "axios";

const New = (props) => {
  const [groupName, setGroupName] = useState("")
  const [groupId, setGroupId] = useState("")

  const [selectedCompanies, setSelectedCompanies] = useState([])
  const [unselectedCompanies, setUnselectedCompanies] = useState(props.unselected_companies)

  const [errorMessage, setErrorMessage] = useState("");

  const addSelectedCompanies = (companyId: number, companyName: string) => {
    let updateSelectedCompanies = [...selectedCompanies, { id: companyId, company_name: companyName }]
    setSelectedCompanies(updateSelectedCompanies)
    let updateUnselectedCompanies = unselectedCompanies.filter(company => company.id !== companyId)
    setUnselectedCompanies(updateUnselectedCompanies)
  }

  const addUnselectedCompanies = (companyId: number, companyName: string) => {
    let updateUnelectedCompanies = [...unselectedCompanies, { id: companyId, company_name: companyName }]
    setUnselectedCompanies(updateUnelectedCompanies)
    let updateSelectedCompanies = selectedCompanies.filter(company => company.id !== companyId)
    setSelectedCompanies(updateSelectedCompanies)
  }

  const onSubmit = () => {
    axios.post(`/api/internal/company_groups/create`,
    {
      m_company_group: {
        name: groupName,
        group_id: groupId,
        selected_companies: selectedCompanies,
        unselected_companies: unselectedCompanies
      }
    }).then(function () {
      location.href = ("/company_group/index");
    })
    .catch(error => {
      setErrorMessage(error.response.data.error)
    });
  }

  return (
    <>
      {errorMessage && 
      <div className="alert alert-danger alert-dismissible" role="alert">
        <button 
            type="button"
            className="close"
            data-dismiss="alert"
            aria-label="閉じる">
          <span aria-hidden="true">×</span>
        </button>{errorMessage}
      </div>}
      <h3>企業グループ登録</h3>
      <div className="container mt50">
        <div className="row">
          <div className="form-group col-md-5">
            <label>グループ名</label>
            <input
              value={groupName}
              onChange={(e) => setGroupName(e.target.value)}
              type="text"
              className="form-control col-lg-1"></input>
          </div>
          <div className="form-group col-md-5">
            <label>グループID</label>
            <input
              value={groupId}
              onChange={(e) => setGroupId(e.target.value)}
              type="text"
              className="form-control col-lg-1"></input>
          </div>
          <div className="form-group col-md-2 text-right">
            <button
              onClick={() => onSubmit()}
              disabled={!groupId || !groupName}
              className="btn btn-primary mt20">登録</button>
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-6 col-lg-6">
            <div>未選択企業</div>
            <ul className="list-group">
              {unselectedCompanies.map((company, i) => {
                return (
                  <li key={i} className="list-group-item">
                    <div className="row">
                      <div className="form-group col-md-9">
                        {company.company_name}
                      </div>
                      <div className="form-group col-md-3">
                        <button       
                          onClick={() => addSelectedCompanies(company.id, company.company_name)}
                          className="btn btn-primary">追加</button>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
          <div className="col-md-6 col-lg-6">
            <div>選択済み企業</div>
            <ul className="list-group">
              {selectedCompanies.map((company, i) => {
                return (
                  <li key={i} className="list-group-item">
                    <div className="row">
                      <div className="form-group col-md-9">
                        {company.company_name}
                      </div>
                      <div className="form-group col-md-3">
                        <button
                          onClick={() => addUnselectedCompanies(company.id, company.company_name)}
                          className="btn btn-danger">削除</button>
                      </div>
                    </div>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
        {/* ボタン類 */}
        <div>
          <div className="actions mt40">
              <a className="btn btn-primary pull-left m5" href="/company_group/index">戻る</a>
          </div>
        </div>
      </div>
    </>
  )
}

export default New
